import { AuthLoginActionTypes, AuthLoginState } from './authTypes';

export const INIT_STATE: AuthLoginState = {
  profile_user: null,
  error: '',
  loading: false,
  isUserLogin: false,
  isUserLogout: true,
  sessionChecked: false,
};

const Login = (state = INIT_STATE, action: any): AuthLoginState => {
  switch (action.type) {

    case AuthLoginActionTypes.SESSION_CHECK:
      return { ...state, loading: true, sessionChecked: false };

    case AuthLoginActionTypes.LOGOUT_USER:
      return { ...state, loading: true };

    case AuthLoginActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {

        case AuthLoginActionTypes.SESSION_CHECK:
          return {
            ...state,
            profile_user: action.payload.data.user ?? null,
            isUserLogin: true,
            isUserLogout: false,
            loading: false,
            sessionChecked: true,
            error: '',
          };

        case AuthLoginActionTypes.LOGOUT_USER:
          return { ...INIT_STATE, sessionChecked: true };

        default:
          return state;
      }

    case AuthLoginActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {

        case AuthLoginActionTypes.SESSION_CHECK:
          return {
            ...INIT_STATE,
            sessionChecked: true,
            error: action.payload.error,
          };

        case AuthLoginActionTypes.LOGOUT_USER:
          return { ...INIT_STATE, sessionChecked: true };

        default:
          return state;
      }

    default:
      return state;
  }
};

export default Login;
